import EventEmitter from './EventEmitter';
class ScriptInjector extends EventEmitter {
    _url;
    constructor(_url) {
        super();
        this._url = _url;
    }
    _onLoad = () => {
        this.emit('load');
    };
    setUrl(url) {
        this._url = url;
    }
    inject() {
        if (!this._url)
            throw new Error('Url is not defined');
        const scriptElement = document.createElement('script');
        scriptElement.src = this._url.toString();
        document.getElementsByTagName('head')[0].appendChild(scriptElement);
        scriptElement.onload = this._onLoad;
    }
}
export default ScriptInjector;
